import React, { useState, useEffect } from "react";
import axios from "axios";

const InputTypeHidden = (props) => {

    return <input
               type="hidden" name={props.name}
               value={props.value}
        />
}

export default InputTypeHidden;